import React from 'react';

import type { Plan } from 'js/src/client/types.gen';
import PricingPlanBlock from 'js/src/components/pricing/PricingPlanBlock';
import type { PlanSwitchErrorInfo } from 'js/src/components/pricing/types';

const PlanBlockList = React.memo(function PlanBlockList({
    plans,
    switchToPlan,
    handlePlanSwitchError,
    scrollToPlans,
}: {
    plans: Plan[];
    switchToPlan: (plan: Plan, with_trial: boolean) => void;
    handlePlanSwitchError: (error_info: PlanSwitchErrorInfo) => void;
    scrollToPlans: (e: React.MouseEvent) => void;
}) {
    if (plans.length === 0) {
        return <div className="plans_placeholder">loading plans...</div>;
    }

    return plans.map((plan, index) => {
        return (
            <PricingPlanBlock
                key={index}
                plan={plan}
                switchToPlan={switchToPlan}
                handlePlanSwitchError={handlePlanSwitchError}
                andMoreClicked={scrollToPlans}
            />
        );
    });
});

export default PlanBlockList;
